<h1>{{ 'referentiels.list.adrProperties.caption' | transloco }}</h1>

@if (userHasReadWritePermission) {
  <div class="flex justify-content-between flex-wrap my-1">
    <div class="flex gap-2">
      <div class="flex justify-content-start gap-2 mb-1">
        <p-button label="{{ 'button.add' | transloco }}" pRipple [rounded]="true" class="btn-light" icon="pi pi-plus" (click)="addNewAdr()" />
      </div>
    </div>
  </div>
}

<div class="card">
  <p-table
    #adrTable
    [(selection)]="selectedAdr"
    [value]="adrResult"
    styleClass="p-datatable-striped"
    selectionMode="single"
    editMode="row"
    [rows]="25"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [rowsPerPageOptions]="[10, 25, 50]"
    [totalRecords]="totalRecords"
    [paginator]="true"
    [loading]="loading"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{{'jgrid.defaults.recordtext' | transloco}} {first} - {last} {{'jgrid.defaults.recordtextOf' | transloco}} {totalRecords}"
    dataKey="id"
  >
    <ng-template pTemplate="header">
      <!-- Headers -->
      <tr>
        <th *ngIf="userHasReadWritePermission" style="width: 5%"></th>
        <th pResizableColumn pSortableColumn="codeHecate" style="width: 10%">{{ 'referentiels.list.adrProperties.codeHecate.header' | transloco }} <p-sortIcon field="codeHecate" /></th>
        <th pResizableColumn pSortableColumn="numeroUN" style="width: 8%">{{ 'referentiels.list.adrProperties.numeroUN.header' | transloco }} <p-sortIcon field="numeroUN" /></th>
        <th pResizableColumn pSortableColumn="designation" style="width: 45%">{{ 'referentiels.list.adrProperties.designation.header' | transloco }} <p-sortIcon field="designation" /></th>
        <th pResizableColumn pSortableColumn="classe" style="width: 8%">{{ 'referentiels.list.adrProperties.classe.header' | transloco }} <p-sortIcon field="classe" /></th>
        <th pResizableColumn pSortableColumn="codeDanger" style="width: 7%">{{ 'referentiels.list.adrProperties.codeDanger.header' | transloco }} <p-sortIcon field="codeDanger" /></th>
        <th pResizableColumn pSortableColumn="groupeEmballage" style="width: 7%">{{ 'referentiels.list.adrProperties.groupeEmballage.header' | transloco }} <p-sortIcon field="groupeEmballage" /></th>
        <th pResizableColumn pSortableColumn="codeTunnels" style="width: 10%">{{ 'referentiels.list.adrProperties.codeTunnels.header' | transloco }} <p-sortIcon field="codeTunnels" /></th>
      </tr>
      <tr>
        <th *ngIf="userHasReadWritePermission"></th>
        <th>
          <p-columnFilter type="text" field="codeHecate" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par Code Hecate" [showMenu]="false" [showClearButton]="false" />
        </th>
        <th>
          <p-columnFilter type="text" field="numeroUN" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par Numéro UN" [showMenu]="false" [showClearButton]="false" />
        </th>
        <th>
          <p-columnFilter type="text" field="designation" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par Désignation" [showMenu]="false" [showClearButton]="false" />
        </th>
        <th>
          <p-columnFilter type="text" field="classe" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par classe" [showMenu]="false" [showClearButton]="false" />
        </th>
        <th>
          <p-columnFilter type="text" field="codeDanger" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par code danger" [showMenu]="false" [showClearButton]="false" />
        </th>
        <th>
          <p-columnFilter type="text" field="groupeEmballage" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par groupe emballage" [showMenu]="false" [showClearButton]="false" />
        </th>
        <th>
          <p-columnFilter type="text" field="codeTunnels" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par Code Tunnels" [showMenu]="false" [showClearButton]="false" />
        </th>
      </tr>
    </ng-template>

    <!-- Body -->
    <ng-template pTemplate="body" let-adr let-index="rowIndex" let-editing="editing">
      <ng-container [formGroup]="adrForm">
        <tr [pEditableRow]="adr" [pSelectableRow]="adr">
          <td *ngIf="userHasReadWritePermission">
            <!-- Column for edit/save buttons -->
            <div class="flex align-items-center justify-content-center">
              <input id="adrId-{{ index }}" pInputText type="hidden" formControlName="id" />
              <button *ngIf="!editing && userHasReadWritePermission" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-sm" (click)="editAdr(adr, index)"></button>
              <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" class="p-button-sm" size="small" (click)="saveRowAdr(adr, index)"></button>
              <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" class="p-button-sm" size="small" (click)="cancelEditRowAdr(adr, index)"></button>
            </div>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="codeHecate-{{ index }}" pInputText type="text" formControlName="codeHecate" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ adr.codeHecate }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="numeroUN-{{ index }}" pInputText type="text" formControlName="numeroUN" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ adr.numeroUN }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="designation-{{ index }}" pInputText type="text" formControlName="designation" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ adr.designation }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="classe-{{ index }}" pInputText type="text" formControlName="classe" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ adr.classe }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="codeDanger-{{ index }}" pInputText type="text" formControlName="codeDanger" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ adr.codeDanger }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="groupeEmballage-{{ index }}" pInputText type="text" formControlName="groupeEmballage" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ adr.groupeEmballage }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="codeTunnels-{{ index }}" pInputText type="text" formControlName="codeTunnels" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ adr.codeTunnels }}
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>
</div>
<p-toast />
